/**
 * Checks whether the rule has been injected already
 * @param {Number} numOfInjections This is called currentRuleInjectedComponentCount, keeps count of how many times injection has happened.
 * @returns {Boolean}
 */
const hasRuleBeenInjected = (numOfInjections) => numOfInjections >= 1;

export default hasRuleBeenInjected;
